var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"swatch",staticStyle:{"position":"absolute"}},[_c('ul',_vm._l((_vm.colors),function(color){return _c('li',[_c('button',{on:{"click":function($event){_vm.updateValue(color.id)}}},[_c('i',{class:['color-swatch-item', 'color-'+color.id]}),_vm._v(" "+_vm._s(color.name))])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60595e90","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Annotator/swatch.vue
// module id = null
// module chunks = 